import styled from 'styled-components'

type Props = {
	isActive: boolean
	hasError: boolean
}

export const Container = styled.div<Props>`
	position: absolute;
	right: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	top: 12px;
	bottom: 12px;
	color: ${({ theme, isActive, hasError }) => {
		if (hasError) return isActive ? theme.color.input.menuIndicatorErrorActive : theme.color.input.menuIndicatorError
		return isActive ? theme.color.input.menuIndicatorActive : theme.color.input.menuIndicator
	}};
	border-left: 1px solid ${({ theme, hasError }) => (hasError ? theme.color.input.menuSeparatorError : theme.color.input.menuSeparator)};
	padding: 0 6px 0 14px;
	flex-shrink: 0;
`
